import {
  faAddressCard,
  faCar,
  faChartPie,
  faCreditCard,
  faHome,
  faTable,
  faUser,
} from "@fortawesome/fontawesome-free-solid";
import {
  faCalendar,
  faFileCirclePlus,
  faFileLines,
  faGear,
  faGhost,
  faListCheck,
  faLocation,
  faLocationCrosshairs,
  faRightFromBracket,
  faUsersGear,
  faVectorSquare,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Skeleton } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import Modal from "../b2b/Modal";

const SideBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, userLoading } = useSelector((state) => state.auth);

  const [addLogoutModal, setaddLogoutModal] = useState(false);
  const [logOut, setLogOut] = useState(false);

  // const handleClickOpen = () => {
  //   setOpen(true);
  // }

  const handleLogout = () => {
    dispatch({ type: "LOGOUT", payload: { navigate } });
  };

  return (
    <div className="hidden md:inline ">
      <div className="flex flex-col p-3 bg-[#F9F5F6] shadow w-64 h-[100vh] overflow-y-auto">
        <div className="space-y-3">
          <div className="flex-1">
            {!userLoading ? (
              <ul className="pt-2 pb-4 space-y-1 text-sm">
                <SideBarItem iconName={faHome} label="Home" routeLink="/home" />
                {(user?.permission?.newBooking?.permission === "ENABLE" ||
                  user?.permission?.newBooking?.permission === "READ_ONLY") && (
                  <SideBarItem
                    iconName={faFileCirclePlus}
                    label="New Booking"
                    routeLink="/newbooking"
                  />
                )}
                {user?.role === "ADMIN" &&
                  user?.permission?.manageBooking?.permission === "ENABLE" && (
                    <SideBarItem
                      iconName={faGhost}
                      label="Offline Booking"
                      routeLink="/offlinebooking"
                    />
                  )}

                {user?.permission?.flatRateBooking?.permission === "ENABLE" && (
                  <SideBarItem
                    iconName={faFileLines}
                    label="Flat Rates"
                    routeLink="/flatrates"
                  />
                )}
                {(user?.permission?.manageBooking?.permission === "ENABLE" ||
                  user?.permission?.manageBooking?.permission ===
                    "READ_ONLY") && (
                  <SideBarItem
                    iconName={faListCheck}
                    label="Manage Booking"
                    routeLink="/manageBooking"
                  />
                )}
                {user?.role === "ADMIN" && (
                  <SideBarItem
                    iconName={faTable}
                    label="Dockets"
                    routeLink="/docket"
                  />
                )}
                {user?.role === "ADMIN" && (
                  <SideBarItem
                    iconName={faTable}
                    label="Invoice"
                    routeLink="/docketInvoice"
                  />
                )}
                {user?.role === "ADMIN" &&
                user?.permission?.affiliate?.permission === "ENABLE" ? (
                  <SideBarItem
                    iconName={faAddressCard}
                    label="Affiliate"
                    routeLink="/affiliate"
                  />
                ) : (
                  user?.role === "USER" &&
                  user?.permission?.affiliate?.permission === "ENABLE" && (
                    <SideBarItem
                      iconName={faAddressCard}
                      label="Affliate"
                      routeLink="/affiliate"
                    />
                  )
                )}

                {user?.role === "ADMIN" &&
                user?.permission?.generalSettings?.permission === "ENABLE" ? (
                  <SideBarItem
                    iconName={faGear}
                    label="Settings"
                    routeLink="/settings"
                  />
                ) : (
                  user?.role === "USER" &&
                  user?.permission?.generalSettings?.permission ===
                    "ENABLE" && (
                    <SideBarItem
                      iconName={faGear}
                      label="Settings"
                      routeLink="/settings"
                    />
                  )
                )}

                {user?.role === "ADMIN" &&
                user?.permission?.regions?.permission === "ENABLE" ? (
                  <SideBarItem
                    iconName={faLocationCrosshairs}
                    label="Regions"
                    routeLink="/regions"
                  />
                ) : (
                  user?.role === "USER" &&
                  user?.permission?.regions?.permission === "ENABLE" && (
                    <SideBarItem
                      iconName={faLocationCrosshairs}
                      label="Regions"
                      routeLink="/regions"
                    />
                  )
                )}

                {user?.permission?.flatRegions?.permission === "ENABLE" && (
                  <SideBarItem
                    iconName={faLocation}
                    label="Flat Regions"
                    routeLink="/flatregions"
                  />
                )}

                <SideBarItem
                  iconName={faUsersGear}
                  label="User Management"
                  routeLink="/usermanagement"
                />
                {user?.role === "ADMIN" &&
                user?.permission.vehicleTypes?.permission === "ENABLE" ? (
                  <SideBarItem
                    iconName={faCar}
                    label="Vehicle Types"
                    routeLink="/vehicletype"
                  />
                ) : (
                  user?.role === "USER" &&
                  user?.permission.vehicleTypes?.permission === "ENABLE" && (
                    <SideBarItem
                      iconName={faCar}
                      label="Vehicle Types"
                      routeLink="/vehicletype"
                    />
                  )
                )}

                {user?.role === "ADMIN" && (
                  <SideBarItem
                    iconName={faChartPie}
                    label="Statistics"
                    routeLink="/statistics"
                  />
                )}
                {user?.role === "ADMIN" && (
                  <SideBarItem
                    iconName={faCalendar}
                    label="Event"
                    routeLink="/event"
                  />
                )}
                {user?.role === "ADMIN" && (
                  <SideBarItem
                    iconName={faCreditCard}
                    label="Credit Card"
                    routeLink="/creditcard"
                  />
                )}
                {/* {user?.role === "ADMIN" && (
                  <SideBarItem
                    iconName={faFileLines}
                    label="API Docs V2"
                    routeLink="/apidocsv2"
                  />
                )} */}

                {user?.role === "ADMIN" ? (
                  <SideBarItem
                    iconName={faFileLines}
                    label="API Docs"
                    routeLink="/apidocs"
                  />
                ) : user.role === "USER" &&
                  user?.permission?.apiDocs?.permission === "ENABLE" ? (
                  <SideBarItem
                    iconName={faFileLines}
                    label="API Docs"
                    routeLink="/apidocs"
                  />
                ) : (
                  <></>
                )}
{/* 
                <SideBarItem
                  iconName={faFileLines}
                  label="Whilte Label Docs"
                  routeLink="/wldocs"
                /> */}

                {user?.role === "ADMIN" ? (
                  <SideBarItem
                    iconName={faFileLines}
                    label="Whilte Label Docs"
                    routeLink="/wldocs"
                  />
                ) : user.role === "USER" &&
                  user?.permission?.whiteLevelDocs?.permission === "ENABLE" ? (
                  <SideBarItem
                    iconName={faFileLines}
                    label="Whilte Label Docs"
                    routeLink="/wldocs"
                  />
                ) : (
                  <></>
                )}

                <div>
                  <div
                    onClick={setaddLogoutModal}
                    className="flex items-center px-5 p-2 space-x-6 rounded-md text-base text-gray-700 hover:bg-gray-200 cursor-pointer mb-10"
                  >
                    <FontAwesomeIcon icon={faRightFromBracket} />
                    <h2 className="font-body">Logout</h2>
                  </div>

                  <div className="flex justify-between ">
                    {addLogoutModal && (
                      <>
                        <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-50">
                          <Modal
                            heading="Log Out"
                            cancelOnClick={() => {
                              setaddLogoutModal(false);
                            }}
                            addOnClick={() => {
                              dispatch({
                                type: "LOGOUT",
                                payload: { navigate },
                              });
                              setaddLogoutModal(false);
                            }}
                            addButtonLabel="Logout"
                            isLoggedOut={true}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </ul>
            ) : (
              <div>
                <div className="space-y-3">
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBar;

export const SideBarItem = ({ iconName, label, routeLink }) => {
  return (
    <>
      <li className="rounded-sm">
        <NavLink
          to={routeLink}
          className={({ isActive }) =>
            isActive
              ? "group flex items-center p-2 space-x-3 rounded-md text-base active:text-white text-white font-normal bg-secondary cursor-pointer"
              : "flex items-center p-2 space-x-3 rounded-md text-base text-gray-700 hover:bg-gray-200 cursor-pointer"
          }
        >
          <FontAwesomeIcon
            icon={iconName}
            className="w-10 group-aria-checked:text-white "
          />
          <span className="font-body">{label}</span>
        </NavLink>
      </li>
    </>
  );
};
